import * as styles from "./styles.css";
import { cn } from "@discovery/classnames";
export const CircularSpinner = ({ customstyle }) => (React.createElement("div", { className: cn(styles.searchLoader, customstyle, {}) },
    React.createElement("div", null),
    React.createElement("div", null),
    React.createElement("div", null),
    React.createElement("div", null)));

